module.exports = "<select data-recipient-selection multiple data-placeholder=\" \" {{disabled}} style=\"width: 100%\"></select>\n"